module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_j_erythristic.f39aab9c.png";